import FJConfig from '../config/FJConfig';
import { RELEASE } from '../constants/FJEvnConstant';
import FJUtil from '../util/FJUtil';
import FJRequirementsUtil from '../util/FJRequirementsUtil.js';
import FJTextToVideoStore from './FJTextToVideoStore.js';
const environment = import.meta.env.MODE; // 当前环境
const BASE_URL = environment === RELEASE ? 'https://www.flexclip.com' : 'https://www.smartvideomaker.com';
const RESOURCE_URL = environment === RELEASE ? 'https://resource.flexclip.com/' : 'https://www.smartvideomaker.com/';
const LOCAL_USER_ID = '362';

const _isTeamSpace = () => {
    // TODO:团队 移动端暂时使用个人积分
    return FJUtil.isTeamSpace() && !FJUtil.isMobile();
};
const _fetch = async (api, formData, method = 'POST') => {
    const url = BASE_URL + api;
    if (FJRequirementsUtil.isLocalhost()) formData.append('uid', LOCAL_USER_ID);
    // else {
    //     const uid = FJUtil.getUserId();
    //     uid && formData.append('uid', uid);
    // }
    const response = await fetch(url, {
        method,
        body: formData,
    });
    const { data, code } = await response.json();
    if (code === 200) {
        return data;
    }
    return null;
};
/**
 * @description 接口验证
 * @param formData
 */
const addCSRFToken = formData => {
    if (window.csrf_token) {
        formData.append(window.csrf_token, 1);
    }
};

export default {
    /**
     * 图生图
     * @param {*} data
     * @returns
     */
    imgToImg: async options => {
        const { prompt, image, negativePrompt, conditionScale, seed, numOutputs, style } = options;
        const url = BASE_URL + '/ai/img-to-img';
        const formData = new FormData();
        formData.append('prompt', prompt);
        formData.append('image', image);
        formData.append('style', style);
        formData.append('num_outputs', numOutputs);

        negativePrompt && formData.append('negative_prompt', negativePrompt);
        conditionScale && formData.append('condition_scale', conditionScale);
        seed && formData.append('seed', seed);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await res.json();
        return { data, code };
    },
    imageProcessing: async options => {
        const {
            image,
            colorize,
            enhance,
            repair,
            factor,
            scratch_repair_mask,
            scratch_repair,
            original_image,
            generate_mask,
        } = options;
        // const { image, colorize, enhance, repair, factor, modelType } = options;
        const url = BASE_URL + '/ai/image-processing';
        const formData = new FormData();
        formData.append('image', image);
        formData.append('colorize', colorize);
        formData.append('enhance', enhance);
        formData.append('repair', repair);
        enhance && formData.append('factor', factor);
        scratch_repair_mask && formData.append('scratch_repair_mask', scratch_repair_mask);
        scratch_repair && formData.append('scratch_repair', scratch_repair);
        original_image && formData.append('original_image', original_image);
        generate_mask && formData.append('generate_mask', generate_mask);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        // enhance && formData.append('model_type', modelType);
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc 生成 自动划痕检测 mask 图
     * @param {*} options
     * @returns
     */
    generateScratchRepairMask: async options => {
        const { imageUrl } = options;
        const url = BASE_URL + '/ai/generate-scratch-repair-mask';
        const formData = new FormData();
        formData.append('image', imageUrl);
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await res.json();

        if (code === 200) {
            return data.mask;
        }
        return null;
    },

    imageEnhancer: async options => {
        const { image, factor } = options;
        const url = BASE_URL + '/ai/image-enhancer-task';
        const formData = new FormData();
        formData.append('image', image);
        formData.append('factor', factor);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await res.json();
        return { data, code };
    },
    clothesChanger: async options => {
        const { image, garment } = options;
        const url = BASE_URL + '/ai/create-clothes-changer-task';
        const formData = new FormData();
        formData.append('image', image);
        formData.append('garment', garment);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await res.json();
        return { data, code };
    },
    /**
     * 获取任务状态
     * @param {} eventId
     * @returns
     */
    getTaskState: async eventId => {
        const api = '/rp/get-state';
        const formData = new FormData();
        formData.append('event_id', eventId);
        try {
            return await _fetch(api, formData);
        } catch (error) {
            return;
        }
    },
    /**
     * 获取任务状态
     * @param {} eventId
     * @returns
     */
    cancelTask: async eventId => {
        const api = '/rp/cancel';
        const formData = new FormData();
        formData.append('event_id', eventId);
        return await _fetch(api, formData);
    },
    /**
     * 获取免费使用次数
     * @returns
     */
    getUseFreeLimit: async () => {
        const api = '/ai/get-use-free-limit';
        const formData = new FormData();
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        return await _fetch(api, formData);
    },
    /**
     * 获取图片列表
     * @param {*} eventType 3：图生图 4:图像处理
     * @returns
     */
    getTaskList: async (eventType = '3') => {
        const api = '/ai/task-list';
        const formData = new FormData();
        formData.append('event_type', eventType);
        return await _fetch(api, formData);
    },
    deleteTaskList: async ids => {
        const url = BASE_URL + '/rp/delete';
        const formData = new FormData();
        formData.append('ids', ids);
        if (FJRequirementsUtil.isLocalhost()) formData.append('uid', LOCAL_USER_ID);

        const response = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await response.json();
        return { data, code };
    },
    /**
     * @description 返回积分额度
     * @returns {Promise<{[p: string]: *}>}
     */
    async getCreditsInfo() {
        let url = BASE_URL + '/user/get-credit-info';
        if (_isTeamSpace()) url += `?tid=${FJUtil.getCurrentSpaceId()}`;

        const res = await fetch(url, { method: 'GET' });
        const { code, data } = await res.json();
        if (code !== 200) {
            throw new Error(code.toString());
        }
        return data;
    },
    async checkIsLogin() {
        const url = BASE_URL + '/user/checkState';
        const res = await fetch(url, {
            method: 'GET',
        });
        const { data, code } = await res.json();
        return data?.result && code == 200;
    },
    async getSpaceData() {
        const url = BASE_URL + '/user/get-space-data';
        const res = await fetch(url, {
            method: 'GET',
        });
        const { code, data } = await res.json();
        if (code !== 200) {
            throw new Error(code.toString());
        }
        return data;
    },

    async textToImage(param) {
        const url = BASE_URL + '/ai/new-text-to-image';
        const formData = new FormData();
        formData.append('prompt', param.prompt);
        formData.append('model_type', param.model_type);
        formData.append('aspect_ratio', param.ratio);
        formData.append('num_outputs', param.generateNumber);
        formData.append('style', param.style);
        formData.append('prompt_val', param.prompt_val);
        formData.append('input_prompt', param.input_prompt);
        if (FJUtil.isLocalhost()) formData.append('uid', LOCAL_USER_ID);

        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },
    async batchTextToImage(param) {
        const url = BASE_URL + '/ai/batch-text-to-image';
        const formData = new FormData();
        formData.append('prompts', param.prompts);
        formData.append('model_type', param.model_type);
        formData.append('aspect_ratio', param.ratio);
        formData.append('num_outputs', param.generateNumber);
        formData.append('style', param.style);
        formData.append('prompt_val', param.prompt_val);
        formData.append('input_prompt', param.input_prompt);
        if (FJUtil.isLocalhost()) formData.append('uid', LOCAL_USER_ID);

        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @description 翻译value
     * @param {JSON} value
     * @param toLanguage
     * @returns {Promise<any>}
     */
    async translateValueToLanguage(value, toLanguage = 'en') {
        // 使用我们的接口
        const formData = new FormData();
        formData.append('data', JSON.stringify(value));
        formData.append('to_language', toLanguage);
        if (FJUtil.isLocalhost()) formData.append('uid', LOCAL_USER_ID);

        const response = await fetch(BASE_URL + '/ai/translate-text', {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await response.json();
        if (code === 200) {
            const list = JSON.parse(data);
            return list;
        }
    },

    /**
     * @description 生成图片描述
     * @param {String} fileUrl
     * @param {String} currentLang
     * @returns {Promise<any>}
     */
    async generateImageByPrompt(fileUrl, currentLang = 'en') {
        const url = BASE_URL + '/ai/generate-image-desc';
        const formData = new FormData();
        formData.append('image', fileUrl);
        formData.append('current_lang', currentLang);

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @description 生成图片描述 - 视频配音接口用
     * @param {String} fileUrl
     * @param {String} currentLang
     * @returns {Promise<any>}
     */
    async generateImageByPromptInAiSfx(fileUrl, currentLang = 'en') {
        const url = BASE_URL + '/v1/ai/generate-image-desc';
        const formData = new FormData();
        formData.append('image', fileUrl);
        formData.append('current_lang', currentLang);

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc AI提示词优化
     * @returns
     */
    async aiOptimizing(prompt) {
        const url = BASE_URL + '/ai/optimization-description';

        const urlWithParams = `${url}?prompt=${prompt}`;

        const res = await fetch(urlWithParams, {
            method: 'GET',
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc AI图片扩展
     * @returns
     */
    async imageExtender(imageUrl, left, right, top, bottom) {
        const url = BASE_URL + '/ai/create-image-extender-task';
        const formData = new FormData();
        formData.append('image', imageUrl);
        formData.append('left', left);
        formData.append('right', right);
        formData.append('top', top);
        formData.append('bottom', bottom);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc AI换脸
     * @returns
     */
    async faceSwap(originImageUrl, targetImageUrl) {
        const url = BASE_URL + '/ai/create-face-swap-task';
        const formData = new FormData();
        formData.append('face_swap_target', originImageUrl);
        formData.append('image', targetImageUrl);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @description 生成深度图
     * @param {String} fileUrl
     * @param {String} currentLang
     * @returns {Promise<any>}
     */
    async generateDepthMap(fileUrl) {
        const url = BASE_URL + '/ai/depth-map';
        const formData = new FormData();
        formData.append('image', fileUrl);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },
    async updateDepthMapInfo(evenId, info) {
        const url = BASE_URL + '/ai/update-depth-map-info';
        const formData = new FormData();
        formData.append('event_id', evenId);
        formData.append('info', info);
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await res.json();
        return { data, code };
    },
    async addUseValue(type, number) {
        const url = BASE_URL + '/ai/add-use-value';
        const formData = new FormData();
        formData.append('type', type);
        formData.append('number', number);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        try {
            const res = await fetch(url, {
                method: 'POST',
                body: formData,
            });
            const { code } = await res.json();
            if (code === 200) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    },

    /**
     * @desc 获取AI mask
     * @returns
     */
    async getAiMask(imageUrl) {
        const url = BASE_URL + '/ai/analyze-image-generate-mask';

        const formData = new FormData();
        formData.append('image', imageUrl);
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();

        if (code === 200) {
            return data && data.json;
        }
        return null;
    },

    /**
     * @desc 物体擦除
     * @returns
     */
    async objectEraserTask(options) {
        const url = BASE_URL + '/ai/object-erasure-task';

        const { image, mask, original_image, prompt } = options;
        const formData = new FormData();
        formData.append('image', image);
        formData.append('mask', mask);
        original_image && formData.append('original_image', original_image);
        prompt && formData.append('prompt', prompt);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc 手动去创建背景擦除历史
     * @returns
     */
    async createRemoveBackgroundHistory(options) {
        const url = BASE_URL + '/ai/create-remove-background-history';
        const formData = new FormData();
        formData.append('filename', options.filename);
        formData.append('original', options.original);
        formData.append('info', JSON.stringify(options.info));
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc 自动去背景
     * @returns
     */
    async autoBackgroundRemove(options) {
        const url = BASE_URL + '/ai/auto-background-remove';
        const formData = new FormData();
        formData.append('image', options.image);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        try {
            const res = await fetch(url, {
                method: 'POST',
                body: formData,
            });

            const { data, code } = await res.json();
            return { data, code };
        } catch (error) {
            return { data: null, code: 500 };
        }
    },

    /**
     * @desc AI生成视频
     * @returns
     */
    async videoGeneration(options) {
        const url = BASE_URL + '/ai/create-video-generation-task';
        const {
            imageUrl,
            generationType,
            modelType,
            prompt,
            duration,
            ratio,
            waterfallRatio,
            source,
            audioActive,
            audioPrompt,
        } = options;
        const formData = new FormData();
        formData.append('generation_type', generationType);
        formData.append('model_type', modelType);
        formData.append('image_url', imageUrl);
        prompt && formData.append('prompt', prompt);
        formData.append('duration', duration);
        formData.append('aspect_ratio', ratio);
        formData.append('waterfall_ratio', waterfallRatio);
        formData.append('source', source);
        formData.append('is_dubbing', audioActive ? 1 : 0);
        audioPrompt && formData.append('audio_prompt', audioPrompt);

        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc 视频去背景添加预测点
     * @returns
     */
    async videoRemoveBackgroundAddPoints(currentTime, objectId, points, base64String) {
        try {
            const normalizedPoints = points.map(p => [p[0], p[1]]);
            const labels = points.map(() => 1);

            const res = await fetch(BASE_URL + '/ai/add-points', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    session_id: '0',
                    frame_index: 0,
                    object_id: objectId,
                    labels,
                    points: normalizedPoints,
                    clear_old_points: true,
                    start_time: currentTime,
                    image_base64: base64String,
                }),
            });

            const data = await res.json();
            return data;
        } catch (err) {
            return null;
        }
    },

    /**
     * @desc 自动视频去背景
     * @returns
     */
    async autoVideoRemoveBackground(options) {
        let fetchUrl = BASE_URL + '/ai/auto-rm-video-bg';

        if (_isTeamSpace()) {
            fetchUrl += `?tid=${FJUtil.getCurrentSpaceId()}`;
        }

        const res = await fetch(fetchUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(options),
        });

        const data = await res.json();

        if (data.code === 200) {
            return data.data;
        }
        return null;
    },

    /**
     * @desc 视频去背景跟踪
     * @returns
     */
    async videoRemoveBackgroundTrack(options) {
        let fetchUrl = BASE_URL + '/ai/manually-rm-video-bg';

        if (_isTeamSpace()) {
            fetchUrl += `?tid=${FJUtil.getCurrentSpaceId()}`;
        }

        const res = await fetch(fetchUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(options),
        });

        const data = await res.json();
        return data;
    },
    async audioGeneration(options) {
        const url = BASE_URL + '/ai/generate-music-task';
        const { audioUrl, voiceUrl, incidentalUrl, lyrics, info } = options;
        const formData = new FormData();
        audioUrl && formData.append('song_file', audioUrl);
        voiceUrl && formData.append('voice_file', voiceUrl);
        incidentalUrl && formData.append('instrumental_file', incidentalUrl);
        lyrics && formData.append('lyrics', lyrics);
        formData.append('info', JSON.stringify(info));
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    async soundEffectGeneration(options) {
        const url = BASE_URL + '/ai/generate-effect';
        const { prompt, isEnglish } = options;
        const formData = new FormData();
        formData.append('prompt', prompt);
        formData.append('need_translation', isEnglish ? 0 : 1);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    async generateLyric(options) {
        const url = BASE_URL + '/ai/generate-lyrics';
        const { content, currentLang } = options;
        const formData = new FormData();
        formData.append('content', content);
        currentLang && formData.append('current_lang', currentLang);

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    async updateEventInfo(options) {
        const url = BASE_URL + '/ai/update-event-info';
        const { eventId, info } = options;
        const formData = new FormData();
        formData.append('event_id', eventId);
        formData.append('info', JSON.stringify(info));

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },
    async regenerateCoverImage(options) {
        const url = BASE_URL + '/ai/regenerate-cover-image';
        const { videoUrl, eventId } = options;
        const formData = new FormData();
        formData.append('event_id', eventId);
        formData.append('url', videoUrl);

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @description 返回语音服务token
     * @returns {Promise<*>}
     */
    async getVoiceServiceToken() {
        const url = BASE_URL + '/ai/get-audio-token';
        const formData = new FormData();
        if (FJUtil.isLocalhost()) {
            formData.append('uid', LOCAL_USER_ID);
        }
        addCSRFToken(formData);
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data } = await res.json();
        const { token } = data;
        return token;
    },
    async getVoiceList(token) {
        const url = 'https://eastus.tts.speech.microsoft.com/cognitiveservices/voices/list';
        const res = await fetch(url, {
            method: 'GET',
            headers: {
                authorization: 'Bearer: ' + token,
            },
        });
        const voiceList = await res.json();
        return voiceList;
    },
    async getTextToSpeechVoices() {
        const url = `${RESOURCE_URL}json/ai/text-to-speech-voices.json?v=${FJConfig.textToSpeechVoicesVersion}`;
        const voiceRes = await fetch(url, {
            method: 'GET',
        });
        const voiceList = await voiceRes.json();
        return voiceList;
    },
    /**
     * @desc 抓取页面/商品数据
     * @param {*} url
     * @returns
     */
    async spiderPageByURL(options) {
        const { type, url } = options;
        const formData = new FormData();
        formData.append('url', url);
        formData.append('type', type);
        addCSRFToken(formData);
        if (FJUtil.isLocalhost()) {
            formData.append('uid', LOCAL_USER_ID);
        }
        const response = await fetch(BASE_URL + '/ai/spider-page', {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await response.json();
        if (code === 200) {
            return JSON.parse(data);
        }
        return null;
    },
    /**
     * @desc 抓取页面数据 1:生成脚本 2：分割脚本 3：生成AI图片提示词 4：生成关键字 5: 文章分析 6: 产品分析 7: ppt分析
     * @param {*} url
     * @returns
     */
    async getChatData(options) {
        const { stream = 0, type, prompt, language } = options;
        const formData = new FormData();
        formData.append('stream', stream);
        formData.append('type', type);
        formData.append('prompt', prompt);
        if (language) {
            formData.append('lang', language);
        }
        addCSRFToken(formData);
        if (FJUtil.isLocalhost()) {
            formData.append('uid', LOCAL_USER_ID);
        }
        let url = BASE_URL + '/ai/get-chat-data';
        const response = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await response.json();
        if (code === 200) {
            return data;
        } else if (code === 401) {
            FJUtil.getCredits(FJTextToVideoStore.getAppType());
            return null;
        }
        return null;
    },
    /**
     * @desc 批量生成谷歌图片
     * @param {*} url
     * @returns
     */
    async geminiGenerateImage(options) {
        const { style, prompt, ratio } = options;
        const formData = new FormData();
        formData.append('style', style);
        formData.append('prompt', prompt);
        formData.append('ratio', ratio);
        formData.append('type', 8);
        addCSRFToken(formData);
        if (FJUtil.isLocalhost()) {
            formData.append('uid', LOCAL_USER_ID);
        }
        let url = BASE_URL + '/ai/gemini-generate-image';
        if (window.vvv === true) url += '?vv=1';
        const response = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const resData = await response.json();
        if (resData.code === 200) {
            return resData.data;
        }
        return null;
    },
    /**
     * @desc 检测语言
     * @param text
     * @returns {Promise<void>}
     */
    async getLanguageInfoByText(text) {
        const formData = new FormData();
        formData.append('data', text);
        addCSRFToken(formData);
        if (FJUtil.isLocalhost()) {
            formData.append('uid', LOCAL_USER_ID);
        }
        const response = await fetch(BASE_URL + '/ai/detect-language', {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await response.json();
        if (code === 200) {
            return JSON.parse(data);
        }
    },
    /**
     * @description 创建工程
     * @param ratio
     * @param projectName
     */
    async createNewProject(ratio, projectName) {
        let url = '/project/new';
        let ratioType = '';
        switch (FJUtil.toFixed(ratio, 2)) {
            case 1.78:
                ratioType = 'landscape';
                break;
            case 0.56:
                ratioType = 'vertical';
                break;
            case 1:
                ratioType = 'square';
                break;
            case 2.33:
                ratioType = 'cinematic';
                break;
            case 0.8:
                ratioType = 'social';
                break;
            default:
                ratioType = 'landscape';
                break;
        }
        const formData = new FormData();
        formData.append('ratio', ratioType);
        formData.append('project_type', 'simple-timeline');
        if (FJUtil.isTeamSpace()) {
            formData.append('t_id', FJUtil.getCurrentSpaceId());
            url = '/teams/create-project';
        }
        if (projectName) {
            formData.append('name', projectName);
        }
        addCSRFToken(formData);
        if (FJUtil.isLocalhost()) {
            formData.append('page_user_id', LOCAL_USER_ID);
        } else {
            formData.append('page_user_id', FJUtil.getUserId());
        }

        const res = await fetch(BASE_URL + url, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
        });
        const json = await res.json();

        const { code } = json;

        if (code === 341 || code === 217) {
            // throw new Error('project limit');
            return null;
        } else if (code === 214 || code === 335 || code === 336) {
            // FJUtil.checkLogin(code);
            // throw new Error('login error');
            return null;
        } else {
            return json.data.key;
        }
    },

    /**
     * @desc 批量生成谷歌图片
     * @param {*} url
     * @returns
     */
    async productCrawler(url) {
        const formData = new FormData();
        formData.append('url', url);
        addCSRFToken(formData);
        if (FJUtil.isLocalhost()) {
            formData.append('uid', LOCAL_USER_ID);
        }

        const response = await fetch(BASE_URL + '/ai/product-crawler', {
            method: 'POST',
            body: formData,
        });

        const resData = await response.json();
        if (resData.code === 200) {
            return resData.data;
        }
        return null;
    },
    /**
     * @desc ppt 转视频
     * @param {*} url
     * @returns
     */
    async pptToVideo(url) {
        const formData = new FormData();
        formData.append('url', url);
        addCSRFToken(formData);
        if (FJUtil.isLocalhost()) {
            formData.append('uid', LOCAL_USER_ID);
        }

        const response = await fetch(BASE_URL + '/ai/doc-to-video', {
            method: 'POST',
            body: formData,
        });

        const resData = await response.json();
        if (resData.code === 200) {
            return resData.data;
        }
        return null;
    },
    // 积分付费
    async payCredit(credit, type) {
        const formData = new FormData();
        formData.append('credit', credit);
        formData.append('name', type);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        if (FJUtil.isLocalhost()) {
            formData.append('uid', LOCAL_USER_ID);
        }
        const url = `${BASE_URL}/user/deduct-credit`;

        try {
            const res = await fetch(url, {
                method: 'POST',
                body: formData,
            });
            const { code } = await res.json();
            if (code === 200) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    },
    async getLimitedTimeCouponInfo(startLimitedTime = true) {
        const url = BASE_URL + '/user/get-limited-time-coupon';

        const formData = new FormData();
        formData.append('enable', startLimitedTime ? 1 : 0);

        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        try {
            const { data, code } = await res.json();

            if (code === 200) {
                return data;
            }

            return null;
        } catch (error) {
            return null;
        }
    },

    /**
     * @desc 创建视频配音任务
     * @returns
     */
    async createVideoDubTask(options) {
        const fetchUrl = BASE_URL + '/ai/video-to-sound-effect';

        const { url, prompt, duration, width, height, removeOriginAudio, resource, inputPrompt } = options;
        const formData = new FormData();
        formData.append('prompt', prompt);
        formData.append('duration', duration);
        formData.append('url', url);
        formData.append('width', width);
        formData.append('height', height);
        formData.append('save_original_audio', removeOriginAudio ? 0 : 1);
        formData.append('resource', resource);
        formData.append('input_prompt', inputPrompt);

        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }

        try {
            const res = await fetch(fetchUrl, {
                method: 'POST',
                body: formData,
            });

            const { data, code } = await res.json();

            return { data, code };
        } catch (error) {
            return null;
        }
    },
    async audioConvertText(audioUrl, language, duration) {
        const api = '/ai/audio-to-word';
        const formData = new FormData();
        formData.append('audio', audioUrl);
        formData.append('lang', language);
        formData.append('duration', duration);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }

        const res = await fetch(api, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },
    async getAIClippingContent(data) {
        const api = '/ai/clipping-content';
        const formData = new FormData();
        formData.append('content', data);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        return await _fetch(api, formData);
    },
};
